export default __webpack_public_path__ + "static/media/EraseIcon.6ee6a350.svg";